<template>
  <component
    :is="block.settings.cta_url_1 ? 'a' : 'div'"
    :href="block.settings.cta_url_1"
    class="navigation-banner large-link"
    :style="{ 'background-color': block.settings.background_color }"
  >
    <responsive-image
      v-if="block.settings.image"
      class="navigation-banner__image"
      :image="image"
      min-max="500-850"
      ratio="30:12"
    />
    <div
      class="navigation-banner__content"
      :class="{
        'navigation-banner__content--no-bg':
          block.settings.padding === 'padding'
      }"
    >
      <h2
        v-if="block.settings.heading"
        class="navigation-banner__heading text-heading-m"
        v-text="block.settings.heading"
      />

      <p
        v-if="block.settings.sub_copy"
        class="navigation-banner__sub-copy text-body-m-regular"
        v-html="block.settings.sub_copy"
      />
      <div
        v-if="block.settings.cta_url_1"
        class="
        button button--text button--has-hover-icon button--transition-hover-icon
        navigation-banner__cta
        "
      >
        <span
          class="button__label navigation-banner__cta-label
            text-other-button-s"
          v-text="block.settings.cta_text_1"
        />
        <span class="button__icon">
          <icon-arrow-right />
        </span>
      </div>
    </div>
  </component>
</template>

<script>

/**
 * Vue: Navigation banner (navigation-banner)
 * -----------------------------------------------------------------------------
 * Banner within mobile & desktop navigation.
 *
 */
import ResponsiveImage from '~global/images/responsive-image'

import IconArrowRight from '~icons/directional-navigation/arrow/right.svg'

export default {
  name: 'NavigationBanner',

  components: {
    ResponsiveImage,
    IconArrowRight,
  },

  props: {
    block: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      image: {
        url: this.block.settings.image,
      },
    }
  },
}
</script>

<style lang="scss">
@import './navigation-banner';
</style>
